<template>
  <div>
    <fieldset class="border p-2">
      <legend>
        <small style="font-size: 15px; font-weight: bold">new bond tracking</small>
      </legend>
      <div>
        <div class="row">
          <div class="col-md-12">
            <fieldset class="border p-3">
              <div class="row">
                <div class="col-md-4">
                  <label style="font-size:13px; font-weight: bold">Customer name:</label>
                  <span style="font-size:13px;">{{Requisition.customer_name}}</span>
                </div>
                <div class="col-md-4">
                  <label style="font-size:13px; font-weight: bold">Cargo no:</label>
                  <span style="font-size:13px;">{{Requisition.container_no}}</span>
                </div>
                <div class="col-md-4">
                  <label style="font-size:13px; font-weight: bold">T812 entry:</label>
                  <span style="font-size:13px;">{{Requisition.t812_entry}}</span>
                </div>
              </div>
              <div class="row">
                <div class="col-md-4">
                  <label style="font-size:13px; font-weight: bold">Truck no:</label>
                  <span style="font-size:13px;">{{Requisition.truck_no}}</span>
                </div>
                <div class="col-md-4">
                  <label style="font-size:13px; font-weight: bold">Trailer no:</label>
                  <span style="font-size:13px;">{{Requisition.trailer_no}}</span>
                </div>
                <div class="col-md-4">
                  <label style="font-size:13px; font-weight: bold">Driver name:</label>
                  <span style="font-size:13px;">{{Requisition.driver_name}}</span>
                </div>
              </div>
            </fieldset>
          </div>
        </div>
        <p></p>
        <p></p>

        <form @submit.prevent="newBondtracking()">
          <div class="row">
            <input type="hidden" class="cargo_id" :value="Requisition.cargo_id" />
            <input type="hidden" class="requisition_id" :value="Requisition.id" />
            <input type="hidden" class="truck_id" :value="Requisition.truck_id" />
            <input type="hidden" class="bond_id" :value="Requisition.bond_id" />
            <div class="col-md-6">
              <div class="form-group">
                <label>Ro</label>
                <select name="Ro" class="form-control Ro input-rounded f-s-14">
                  <option value>Select RO</option>
                  <option value="YES">YES</option>
                  <option value="NO">NO</option>
                </select>
              </div>
              <div class="form-group">
                <label>Coe</label>
                <select name="coe" class="form-control coe input-rounded f-s-14">
                  <option value>Select coe</option>
                  <option value="YES">YES</option>
                  <option value="NO">NO</option>
                </select>
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label>Loading report</label>
                <select name="l_reporting" class="form-control l_reporting input-rounded f-s-14">
                  <option value>Select Loadin report</option>
                  <option value="YES">YES</option>
                  <option value="NO">NO</option>
                </select>
              </div>
              <div class="form-group">
                <label>malaba collection</label>
                <input
                  type="date"
                  class="form-control ml_collection input-rounded f-s-14"
                  placeholder="malaba collection"
                />
              </div>
            </div>
          </div>
          <button type="submit" class="btn btn-primary btn-flat creatingBondtracking btn-rounded">
            <i class="fa fa-plus"></i> Add tracking
          </button>
          <button type="button" class="btn-rounded btn-flat creatingBondtrackingLoader btn-rounded">
            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
            <i class="fa fa-spinner fa-spin" style="font-size:24px"></i> please wait...
          </button>
        </form>
      </div>
    </fieldset>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import $ from "jquery";
import router from "../router/index";
export default {
  created() {
    if (this.$store.getters.Requisition.length === 0) {
      router.push("/managerequisitions");
    }
  },

  computed: {
    ...mapGetters(["Requisition"])
  },

  methods: {
    ...mapActions(["newBondtracking"])
  }
};
</script>
<style scoped>
.creatingBondtrackingLoader {
  display: none;
}
</style>


// WEBPACK FOOTER //
// src/bondtrackings/bondtracking.vue